import { deleteNewsletterResponseMultipleNewsletter } from 'modules/newsletters/storeBuilder'
import styles from './StatusBar.module.scss'

const StatusBar = ({ children = null }) => {
    return <div className={styles.statusbar}>{children}</div>

}

export default StatusBar
